import { cloneDeep } from "lodash";
import { path } from "../../api";
import { restClient } from "../../utils/restClient";

const initialState = {};

export default {
  namespaced: true,
  name: "jackpot",
  state: cloneDeep(initialState),
  mutations: {},
  actions: {
    async getNotifications() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.jackpot.notifications,
            "GET"
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
    async markViewed(_, payload) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const response = await restClient(
            path.client.jackpot.markViewed(payload.id),
            "PUT"
          );
          resolve(response);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
